module.exports = __webpack_public_path__ + "static/media/abt_icon3.10485057.svg";